import React, { useState } from 'react';
import './galerie.css';
import Lightbox from '../components/Lightbox';

const Galerie = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Définir le nombre d'images par section
  const sections = [
    { title: "Le Hameau", path: "lehameau", count: 14 },
    { title: "La maison (Extérieur)", path: "lamaison-exterieur", count: 13 },
    { title: "La maison (Intérieur)", path: "lamaison-interieur", count: 16 },
    { title: "Le Fournil", path: "lefour", count: 7 },
    { title: "Le Préau", path: "lepreau", count: 10 },
    // { title: "L'étable du Sorbier", path: null, count: 0 }, // Coming soon
    // { title: "La grange du Sorbier", path: null, count: 0 } // Coming soon
  ];

  return (
    <div className="galerie-container">
      <h1 className="galerie-title">Galerie</h1>

      {sections.map((section, idx) => (
        <section 
          key={idx} 
          className={`galerie-section ${section.count === 0 ? "coming-soon" : ""}`}
        >
          <h2>{section.title}</h2>

          {section.count > 0 ? (
            <div className="galerie-grid">
              {Array.from({ length: section.count }, (_, i) => i + 1).map(i => (
                <div key={i} className="galerie-img">
                  <img
                    src={`/img/galerie/${section.path}/img${i}.jpg`}
                    alt={`${section.title} ${i}`}
                    onClick={() => setSelectedImage(`/img/galerie/${section.path}/img${i}.jpg`)}
                  />
                </div>
              ))}
            </div>
          ) : (
            <p>📸 Coming soon...</p>
          )}
        </section>
      ))}

      <Lightbox image={selectedImage} onClose={() => setSelectedImage(null)} />
    </div>
  );
};

export default Galerie;
